//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"CuttingTargets",0,"SelectNXObjectList",0],[1,"CuttingTool",0,"SelectNXObject",0],[0,"Name",1,0]],[[["tool"],"SetCuttingTool",{},1,1],[["target_web"],"SetTargetWeb",{},1,1],[["partOcc","bCreateRigid","bCreateJoint","bCreateMotor","cuttingDirection","cuttingPosition","cuttingStartTime","bEnableTimeInterval","cuttingTimeInterval"],"CreateWebCutterAssociatedPhysicsObjects",{R_:{resultMessage:''}},9,0]],[]];
SPLM.Mechatronics.WebCutterBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.WebCutterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;